export function subscriptionStatusLabel(status?: string | null, isTestOrganization = false, fallback = 'Unknown'): string {
    if (isTestOrganization)
        return 'Test Organization';
    if (status === 'app_trial')
        return 'Free Trial';
    if (!status)
        return fallback;
    return status.replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase());
}
